<template>
  <div class="mb-4 flex">
    <InputText type="text" v-model="inputValue" />
    <Button
      icon="pi pi-search"
      class="button-search"
      @click="searchRecipes()"
    />
  </div>
  <div v-for="item in data" :key="item.type" class="div-filter mr-4 mb-4">
    <MultiSelect
      v-model="item.selected"
      :options="item.values"
      optionLabel="name"
      :placeholder="$t('recipes.' + item.type)"
      :filter="item.filter"
      class="multiselect-custom"
      display="chip"
      @change="change(item.type)"
      @filter="filter($event)"
      v-if="item.tag === 'multiselect'"
      :key="item.type"
    >
      <template #chip="slotProps">
        <div>{{ $t(slotProps.value.attributes.key) }}</div>
        <template v-if="!slotProps.value || slotProps.value.length === 0">
          {{ $t("recipes." + item.type) }}
        </template>
      </template>
      <template #option="slotProps">
        <div class="country-item">
          <div>{{ $t(slotProps.option.attributes.key) }}</div>
        </div>
      </template>
    </MultiSelect>
    <div v-if="item.tag === 'overlay'" class="container-overlay">
      <Button
        type="button"
        :label="$t('recipes.' + item.type)"
        @click="toggle"
        class="calories-button"
        icon="pi pi-angle-down"
        iconPos="right"
      />
      <OverlayPanel ref="op" id="range_panel" :showCloseIcon="true">
        {{ $t("calories.min")
        }}<InputNumber v-model="range[0]" :min="0" :max="range[1]" />
        {{ $t("calories.max")
        }}<InputNumber v-model="range[1]" :min="range[0]" :max="2077" />
        <Button
          :label="$t('calories.apply')"
          @click="change(item.type)"
          class="mt-4"
        />
      </OverlayPanel>
    </div>
  </div>
</template>

<script>
import { fetchIngredients } from "../../service/IngredientsService";
import { fetchFeatures } from "../../service/FeatureService";
import { fetchCategories } from "../../service/CategoryService";
import { fetchSeoTags } from "../../service/SeoTagsService";
import RecipeService from "../../service/RecipeService";

export default {
  data() {
    return {
      inputValue: "",
      recipeService: null,
      range: [0, 2077],
      filters: {
        category: [],
        ingredients: [],
        features: [],
        difficulty: [],
        cost: [],
        calories: [],
        seotags: [],
        general: [],
      },
      data: [
        {
          type: "category",
          selected: [],
          values: [],
          tag: "multiselect",
          filter: false,
        },
        {
          type: "ingredients",
          selected: [],
          values: [],
          filtered: [],
          tag: "multiselect",
          filter: true,
        },
        {
          type: "features",
          selected: [],
          values: [],
          filtered: [],
          tag: "multiselect",
          filter: false,
        },
        {
          type: "difficulty",
          selected: [],
          values: [
            { attributes: { key: "difficulty.very_low" } },
            { attributes: { key: "difficulty.low" } },
            { attributes: { key: "difficulty.average" } },
            { attributes: { key: "difficulty.high" } },
            { attributes: { key: "difficulty.very_high" } },
          ],
          filtered: [],
          tag: "multiselect",
          filter: false,
        },
        {
          type: "cost",
          selected: [],
          values: [
            { attributes: { key: "cost.very_low" } },
            { attributes: { key: "cost.low" } },
            { attributes: { key: "cost.average" } },
            { attributes: { key: "cost.high" } },
            { attributes: { key: "cost.very_high" } },
          ],
          filtered: [],
          tag: "multiselect",
          filter: false,
        },
        {
          type: "calories",
          selected: [],
          values: [],
          tag: "overlay",
          filter: false,
        },
        {
          type: "seotags",
          selected: [],
          values: [],
          tag: "multiselect",
          filter: false,
        },
      ],
      filteredIngredients: [],
    };
  },
  created() {
    this.recipeService = new RecipeService();
  },
  computed: {
    locale: function() {
      return this.$store.getters["preferences/locale"];
    },
    access_token: function() {
      return this.$store.getters["userdata/getAccessToken"];
    },
    languages: function() {
      return this.$store.getters["labels/languages"];
    },
    recipeList: {
      get() {
        return this.$store.state.recipeCategory.recipes;
      },
      set(value) {
        this.$store.commit("recipeCategory/setRecipes", value);
      },
    },
    total: {
      get() {
        return this.$store.state.recipeCategory.total;
      },
      set(value) {
        this.$store.commit("recipeCategory/setTotal", value);
      },
    },
    pageSize: function() {
      return this.$store.getters["recipeCategory/pageSize"];
    },
  },
  async mounted() {
    await this.fetchData("ingredients", fetchIngredients);
    this.fetchData("features", fetchFeatures);
    this.fetchData("seotags", fetchSeoTags);
    this.fetchData("category", fetchCategories);
    let data = this.data.find((o) => o.type === "ingredients");
    data.filtered = [...data.values];
  },
  methods: {
    async fetchData(type, functionName) {
      let data = this.data.find((o) => o.type === type);
      await functionName(this.access_token).then((res) => {
        data.values = res;
        this.importTranslations(res);
      });
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    async importTranslations(items) {
      let translations = new Array(this.languages.length);
      this.languages.forEach((elem, index) => {
        translations[index] = {};
        translations[index].locale = elem.code;
        translations[index].labels = {};
      });
      items.forEach((elem) => {
        var path = elem.attributes.key;
        elem.attributes.labels.data.forEach((label) => {
          let index = translations.findIndex(
            (x) => x.locale === label.attributes.locale
          );
          var value = label.attributes.value;
          var obj = translations[index].labels;
          var parts = path.split("."),
            part;
          var last = parts.pop();
          // eslint-disable-next-line no-cond-assign
          while ((part = parts.shift())) {
            if (typeof obj[part] != "object") obj[part] = {};
            obj = obj[part]; // update "pointer"
          }
          obj[last] = value;
        });
      });
      translations.forEach((elem) => {
        let old = this.$i18n.getLocaleMessage(elem.locale);
        this.$i18n.setLocaleMessage(elem.locale, {
          ...old,
          ...elem.labels,
        });
      });
    },
    filter(event) {
      let data = this.data.find((o) => o.type === "ingredients");
      if (!event.value.trim().length) {
        data.values = [...data.filtered];
      } else {
        data.values = [...data.filtered]
          //TODO unire i filter
          //cerco per lingua e nome cercato
          .filter((ingredient) => {
            let ingredientsTitle = ingredient.attributes.labels.data.find(
              (o) => o.attributes.locale === this.locale
            );
            return ingredientsTitle.attributes.value
              .toLowerCase()
              .includes(event.value.toLowerCase());
          });
      }
      return data.values;
    },
    getOrFilters(type) {
      let array = [];
      let data = this.data.find((o) => o.type === type);
      if (data.selected.length === 0) {
        this.filters[type] = [];
      }
      data.selected.forEach((item, index) => {
        let str = "filters[" + type + "][$in][" + index + "]";
        array.push({ [str]: item.attributes.key });
        this.filters[type] = [...array];
      });
    },
    getIngredientsFilters(type) {
      let array = [];
      let data = this.data.find((o) => o.type === type);
      if (data.selected.length === 0) {
        this.filters[type] = [];
      }
      data.selected.forEach((item, index) => {
        let str =
          "filters[$and][" + index + "][" + type + "][ingredient][id][$eq]";
        array.push({ [str]: item.id });
        this.filters[type] = [...array];
      });
    },
    getOrFiltersWithSubLevel(type) {
      let array = [];
      let data = this.data.find((o) => o.type === type);
      if (data.selected.length === 0) {
        this.filters[type] = [];
      }
      data.selected.forEach((item, index) => {
        let str = "filters[" + type + "][key][$in][" + index + "]";
        array.push({ [str]: item.attributes.key });
        this.filters[type] = [...array];
      });
    },
    getCaloriesFilters(type) {
      let array = [];
      let data = this.data.find((o) => o.type === type);
      if (data.selected.length === 0) {
        this.filters[type] = [];
      }
      let lte = "filters[$and][0][" + type + "][$lte]";
      let gte = "filters[$and][1][" + type + "][$gte]";
      array.push({ [lte]: this.range[1] });
      array.push({ [gte]: this.range[0] });
      this.filters[type] = [...array];
    },
    change(type) {
      if (type === "difficulty" || type === "cost") {
        this.getOrFilters(type);
      } else if (type === "calories") {
        this.getCaloriesFilters("calories");
      } else if (
        type === "features" ||
        type === "category" ||
        type === "seotags"
      ) {
        this.getOrFiltersWithSubLevel(type);
      } else if (type === "ingredients") {
        this.getIngredientsFilters("ingredients");
      }
      this.fetchRecipes(
        Array.prototype.concat.apply([], Object.values(this.filters))
      );
    },
    async fetchRecipes(query) {
      let params = {
        "sort[0]": "id",
        "pagination[page]": this.$parent.getPage(),
        "pagination[pageSize]": this.pageSize,
        "populate[labels][fields][0]": "key,title,locale",
        "populate[media][fields][1]": "url",
        "populate[category][fields][2]": "key",
        "populate[ingredients][populate]": "ingredient",
        "populate[seotags][populate][labels][fields]": "key,value,locale",
        populate: "features",
      };
      query.map((e) => {
        params = { ...params, ...e };
      });
      await this.recipeService
        .getRecipes(this.access_token, params)
        .then(async (res) => {
          this.total = res.meta.pagination.total;
          this.recipeList = res.data;
          await this.importRecipesTranslations();
        });
    },
    async importRecipesTranslations() {
      let translations = new Array(this.languages.length);
      this.languages.forEach((elem, index) => {
        translations[index] = {};
        translations[index].locale = elem.code;
        translations[index].labels = {};
      });
      this.recipeList.forEach((elem) => {
        var path = elem.attributes.key;
        elem.attributes.labels.data.forEach((label) => {
          let index = translations.findIndex(
            (x) => x.locale === label.attributes.locale
          );
          var value = label.attributes.title;
          var obj = translations[index].labels;
          var parts = path.split("."),
            part;
          var last = parts.pop();
          // eslint-disable-next-line no-cond-assign
          while ((part = parts.shift())) {
            if (typeof obj[part] != "object") obj[part] = {};
            obj = obj[part]; // update "pointer"
          }
          obj[last] = value;
        });
      });
      translations.forEach((elem) => {
        let old = this.$i18n.getLocaleMessage(elem.locale);
        this.$i18n.setLocaleMessage(elem.locale, {
          ...old,
          ...elem.labels,
        });
      });
    },
    searchRecipes() {
      let array = [
        { "populate[labels][filters][$and][0][locale][$eq]": this.locale },
        { "filters[$and][0][labels][locale][$eq]": this.locale },
        { "filters[$and][1][labels][title][$containsi]": this.inputValue },
      ];
      this.filters["general"] = [...array];
      this.fetchRecipes(
        Array.prototype.concat.apply([], Object.values(this.filters))
      );
    },
  },
};
</script>

<style></style>
